<template>
  <v-data-table
    :headers="headers"
    :items="questionnaires"
    :items-per-page="5"
    :loading="loadingQuestionnaires"
    class="elevation-1"
  ></v-data-table>
</template>

<script>

let rh = require('@/components/APIs/RequestHandler')

export default {
  name: 'QuestionnaireComponent',
  data: function () {
    return {
      questionnaires: [],
      loadingQuestionnaires: false,
      selectedQuestionnaires: [],
      filteredQuestionnaires: [],
      headers: [
        {
          text: 'id',
          align: 'start',
          sortable: true,
          value: 'id'
        },
        { text: 'name', value: 'name' },
        { text: 'description', value: 'description' },
        { text: 'active', value: 'active' },
        { text: 'image url', value: 'imageUrl' },
        { text: 'incentive template id', value: 'incentiveTemplateId' },
        { text: 'dismiss message', value: 'dismissMessage' },
        { text: 'incentive text', value: 'incentiveText' },
        { text: 'created date', value: 'created_date' },
        { text: 'updated date', value: 'updated_date' }
      ]
    }
  },
  props: [],
  methods: {
    async initialize () {
      if (
        sessionStorage.getItem('questionnaires') === undefined ||
        sessionStorage.getItem('questionnaires') === null
      ) {
        this.refreshQuestionnaires()
      } else {
        this.questionnaires = JSON.parse(sessionStorage.getItem('questionnaires'))
        this.filteredQuestionnaires = this.questionnaires
      }
    },

    async refreshQuestionnaires () {
      this.loadingQuestionnaires = true
      this.selectedQuestionnaires = []
      this.questionnaires = []
      this.filteredQuestionnaires = []
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_QUESTIONNAIRE}/questionnaires/`

      var getResponse = await rh.default
        .get(endpoint, true)
        .catch((e) => {
          this.errors.push(e)
        })
        .then((value) => {
          this.questionnaires = value.data
          this.filteredQuestionnaires = value.data

          // Save users to session storage
          sessionStorage.setItem('questionnaires', JSON.stringify(value.data))
        })
      this.loadingQuestionnaires = false
    }
  },
  created: function () {
    this.initialize()
  }
}
</script>
